import styled from 'styled-components';
import { rem } from 'polished';
import Icon from '../../core/Icon';
import Avatar from '../../core/Avatar';
import BoxName from '../../core/BoxName';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import MenuBox from '../../core/MenuBox';

// Caja general de la parte inferior del header, logo navaja, Avatar.../
export const StyledHeaderBox = styled.div`
  align-items: flex-end;
  /* background-color: ${props => props.theme.colors.light}; */
  display: none;
  justify-content: space-between;
  height: ${rem('127px')};
  max-width: ${rem('1232px')};
  margin: auto;
  padding: 0 ${rem('17px')} 0 ${rem('16px')};
  position: relative;
  width: 100%;
  z-index: 4;
  ${mediaqueries.greaterThan('mobile')`
    height: ${rem('213px')};
    padding: ${rem('14px')} ${rem('40px')} 0 ${rem('25px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    height: ${rem('230px')};
    padding: ${rem('14px')} 0 0 0;
  `};
`;

// Logo Mobile
export const StyledLogoMobile = styled(Icon)`
  cursor: default;
  display: none;
  max-height: ${rem('191px')};
  position: relative;
  top: ${rem('3px')};
  width: ${rem('183px')};
  ${mediaqueries.greaterThan('360px')`
    display:block;
  `};
  ${mediaqueries.greaterThan('mobile')`
    width: ${rem('300px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    display:none;
  `};
`;

// Contendor Logos
export const Styledleft = styled.div`
  align-items: flex-end;
  display: flex;
`;

// Logo solo navaja
export const StyledRazor = styled(Icon)`
  display: block;
  width: ${rem('83px')};
  ${mediaqueries.greaterThan('360px')`
    display:none;
  `};
`;

// Caja parte derecha Nombre.... y avatar
export const StyledBoxLateral = styled.div`
  display: flex;
  height: 100%;
  position: relative;
`;

/* Componente nombre + desplegable + frase del dia... */
export const StyledBoxName = styled(BoxName)`
  margin-right: ${rem('14px')};
  padding-top: ${rem('36px')};
  justify-content: center;
  ${mediaqueries.greaterThan('mobile')`
    padding-top: ${rem('56px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    margin-right:0;
    padding: ${rem('80px')} 0 ${rem('13px')} 0;
    width: ${rem('458px')};
  `};
`;

/* triangulo para desplegar el listado */
export const StyledIconCollapse = styled(Icon)`
  display: none;
  position: absolute;
  right: 0;
  top: ${rem('14px')};
  width: ${rem('16px')};
  z-index: 7;
  ${mediaqueries.greaterThan('desktop')`
    display:block;
  `};
`;

// Logo atresmil con navaja
export const StyledLogo = styled(Icon)`
  cursor: pointer;
  display: none;
  ${mediaqueries.lessThan('desktop')`
    display: block;
    width :${props => props.resize || rem('433px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    display: block;
    width: ${props => props.resize || rem('433px')};
  `};
`;

// Estilos avatar

export const StyledAvatar = styled(Avatar)`
  top: ${rem('2px')};
  width: ${rem('136px')};
  ${mediaqueries.greaterThan('mobile')`
    top: 0;
    width: ${rem('215px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    margin-left:${rem('14px')};
    top:${rem('2px')};
    width: ${rem('232px')};
  `};
`;

// Listado desplegable en el nombre
export const StyledList = styled(MenuBox)`
  display: none;
  position: absolute;
  top: ${rem('99px')};
  right: ${rem('16px')};
  z-index: 2;
  ${mediaqueries.greaterThan('desktop')`
    display:block;
  `};
`;
